import { AudioAssessmentResult } from '@/types/pronouciation';
import { Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface WordRatingTableProps {
    words: AudioAssessmentResult['characters'];
}

export const WordRatingTable: React.FC<WordRatingTableProps> = ({ words }) => {
    const { t } = useTranslation();
    if (!words || words.length === 0) {
        return (
            <Box sx={{ p: 2, textAlign: 'center' }}>
                <Typography color='text.secondary'>{t('assessment.audio.label.assessmentTextIsEmpty')}</Typography>
            </Box>
        );
    }

    return (
        <TableContainer
            component={Paper}
            sx={{
                border: '1px solid',
                borderColor: 'divider',
            }}
        >
            <Table stickyHeader size='small'>
                <TableHead>
                    <TableRow>
                        <TableCell sx={{ fontWeight: 'bold', backgroundColor: 'divider' }}>{t('assessment.audio.word')}</TableCell>
                        <TableCell align='center' sx={{ fontWeight: 'bold', backgroundColor: 'divider' }}>
                            {t('assessment.audio.pronunciation')}
                        </TableCell>
                        <TableCell align='center' sx={{ fontWeight: 'bold', backgroundColor: 'divider' }}>
                            {t('assessment.audio.tone')}
                        </TableCell>
                        <TableCell align='center' sx={{ fontWeight: 'bold', backgroundColor: 'divider' }}>
                            {t('assessment.audio.initial')}
                        </TableCell>
                        <TableCell align='center' sx={{ fontWeight: 'bold', backgroundColor: 'divider' }}>
                            {t('assessment.audio.vowel')}
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {words.map((word, index) => (
                        <TableRow
                            key={index}
                            sx={{
                                '&:nth-of-type(odd)': { backgroundColor: 'grey.25' },
                                '&:hover': { backgroundColor: 'action.hover' },
                            }}
                        >
                            <TableCell
                                component='th'
                                scope='row'
                                width={'20%'}
                                sx={{
                                    fontWeight: 'medium',
                                    fontSize: '1.1rem',
                                }}
                            >
                                {word.text}
                            </TableCell>
                            <TableCell
                                align='center'
                                width={'20%'}
                                sx={{
                                    fontWeight: 'medium',
                                }}
                            >
                                {word.scores.pronunciation}
                            </TableCell>
                            <TableCell
                                align='center'
                                width={'20%'}
                                sx={{
                                    fontWeight: 'medium',
                                }}
                            >
                                {word.scores.tone}
                            </TableCell>
                            <TableCell
                                align='center'
                                width={'20%'}
                                sx={{
                                    fontWeight: 'medium',
                                }}
                            >
                                {word.scores.initial}
                            </TableCell>
                            <TableCell
                                align='center'
                                width={'20%'}
                                sx={{
                                    fontWeight: 'medium',
                                }}
                            >
                                <Typography>{word.scores.vowel}</Typography>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};
